import { render, staticRenderFns } from "./Nothing.vue?vue&type=template&id=7a08da70"
import script from "./Nothing.vue?vue&type=script&lang=js"
export * from "./Nothing.vue?vue&type=script&lang=js"
import style0 from "./Nothing.vue?vue&type=style&index=0&id=7a08da70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports